/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureUserDaysStatModel(state, data) {
  return {
    groupDate: lc.get(data, 'group_date'),
    groupDateDesc: lc.get(data, 'group_date_desc'),
    userId: lc.get(data, 'user_id'),
    execCount: lc.get(data, 'exec_count'),
    execSum: lc.get(data, 'exec_sum'),
    taskCount: lc.get(data, 'task_count'),
    taskSum: lc.get(data, 'task_sum'),
    refRegCounter: lc.get(data, 'ref_reg_counter'),
    ref2RegCounter: lc.get(data, 'ref_2_reg_counter'),
    refSum: lc.get(data, 'ref_sum'),
    balance: lc.get(data, 'balance')
  };
}

export function restructureUserDaysStatTotalModel(state, data) {
  return {
    countReferral: lc.get(data, 'count_referral'),
    refSum: lc.get(data, 'ref_sum')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userDaysStat/services/UserDaysStatService/restructuring/index.js